package ovh.plrapps.mapcompose.ui.gestures.model

enum class HitType {
    Click, LongPress
}